import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const mentionedUrlsResolver: FieldResolver = (metadata: Metadata) =>
  ({ mentionedUrls: metadata.getMentionedUrls() } as StreamData)

export default mentionedUrlsResolver
